const formatHour = (dateInUTC, brazilGTMOffset = 3) => {
  const currentDateTime = new Date(dateInUTC)
  currentDateTime.setHours(currentDateTime.getHours() - brazilGTMOffset)
  const hour = currentDateTime.getHours()
  const minutes = currentDateTime.getMinutes()
  const formattedHour = hour <= 9 ? `0${hour}` : hour
  const formattedMinutes = minutes <= 9 ? `0${minutes}` : minutes

  return `${formattedHour}h${formattedMinutes}min`
}

export { formatHour }
